import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth-service';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  // ✅ Allow old /manage-rfp/vendor-rfp-page without login (just in case)
  if (state.url.includes('/manage-rfp/vendor-rfp-page')) {
    return true;
  }

  if (this.authService.isLoggedIn()) {
    return true;
  } else {
    this.router.navigate(['login']);
    return false;
  }
}
}

